import { parseDentes } from "@bookdental/schemas";
import type { CondicaoDaArcada } from "@/components/odontograma/Arcada";

/** Cor de item sem cor própria (texto livre ou procedimento sem cor) — zinc-400. */
export const COR_NEUTRA = "#A1A1AA";

type ItemComCor = {
  id: string;
  nome: string;
  dentes: string | null;
  feitoEm: Date | string | null;
  offeredService: { color: string | null } | null;
};

export const corDoItem = (i: ItemComCor) => i.offeredService?.color || COR_NEUTRA;

/**
 * Pinta a arcada pelo plano: cada dente leva a cor do procedimento — clara enquanto planejado,
 * cheia quando feito. A biblioteca só aceita uma cor por dente, então vale o próximo item pendente
 * daquele dente (é o que falta fazer); sem pendente, o último feito. Com `destacadoId` (item sob o mouse
 * na lista), os dentes daquele item ficam em cor cheia e o resto do plano apaga.
 */
export function condicoesDoPlano(
  itens: ItemComCor[],
  destacadoId: string | null = null,
): CondicaoDaArcada[] {
  const dono = new Map<string, ItemComCor>();
  for (const item of itens) {
    for (const fdi of parseDentes(item.dentes)) {
      const atual = dono.get(fdi);
      if (!atual) dono.set(fdi, item);
      else if (atual.feitoEm && !item.feitoEm) dono.set(fdi, item);
      else if (atual.feitoEm && item.feitoEm) dono.set(fdi, item);
    }
  }
  const destacado = itens.find((i) => i.id === destacadoId);
  if (destacado) {
    const deles = new Set(parseDentes(destacado.dentes));
    const cor = corDoItem(destacado);
    const apagados = [...dono.keys()].filter((fdi) => !deles.has(fdi));
    return [
      { rotulo: "outros", dentes: apagados, contorno: "#D4D4D8", preenchimento: "#F4F4F5" },
      { rotulo: destacado.nome, dentes: [...deles], contorno: cor, preenchimento: cor },
    ].filter((c) => c.dentes.length > 0);
  }
  return itens
    .map((item) => {
      const cor = corDoItem(item);
      const dentes = [...dono.entries()].filter(([, d]) => d.id === item.id).map(([fdi]) => fdi);
      return { rotulo: item.nome, dentes, contorno: cor, preenchimento: item.feitoEm ? cor : `${cor}40` };
    })
    .filter((c) => c.dentes.length > 0);
}
